export namespace Location {
  export function href(): string {
    return window.location.href;
  }

  export function setUrl(url: string) {
    window.location.href = url;
  }

  export function search(): string {
    return window.location.search;
  }

  export function replace(url: string) {
    window.location.replace(url);
  }

  export function reload() {
    window.location.reload();
  }

  /**
   * Returns string in the form '#/somehash'
   */
  export function hash(): string {
    return window.location.hash;
  }

  export function setHash(newHash: string): void {
    window.location.hash = newHash;
  }
}
